// import color from "../../../constants/color";

import color from "../../../../constants/color";

const styles = {
  heading: {
    fontSize: "20px",
    fontWeight: "600",
  },
  TableHead: {
    color: color.lightText,
    fontWeight: "400",
    whiteSpace: "nowrap",
    overflow: "hidden",

  },
  mainSection: {
    backgroundColor: color.card,
    m: 2,
    borderRadius: "20px",
  },
  tableAlign: {
    borderBottom: 0,
    display: "flex",
    alignItems: "center",
  },
  tableIcon: {
    borderBottom: 0,
    display: "flex",
    alignItems: "center",
  },
  tableData: {
    borderBottom: 0,
    whiteSpace: "nowrap",
    overflow: "hidden",

  },
  empName: {
    fontSize: "14px",
    fontWeight: "400",

  },
  empEmail: {
    fontSize: "14px",
    fontWeight: "400",
    color: color?.lightText,

  },
  deleteIcon: {
    color: "#ff0000",
    cursor: "pointer"
  },
  input: {
    width: "100%",
    borderRadius: "8px",
    my: 1,
    height: "2.5em",
    marginBottom: "1em"
  },
  space: {
    my: 2
  },
  modalInput: {
    display: "flex",    // backgroundColor:color.lightGray,
    justifyContent: "center",// Center align on smaller screens
    my: "10px",
    height: "2.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8.5px 14px"
    },
    "& .MuiOutlinedInput-root": {
      padding: "0"
    },
    "& .MuiFormHelperText-root.Mui-error": {
      color: "#FF0000",
      ml: "2px"
    },
  },
  inputSpace: {
    "& .MuiOutlinedInput-root": {
      padding: "0px 0px"
    }

  },
  calenderInput: {
    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
      width: "250px",
    }
  },
  noteInput: {
    height: "4.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "14px"
    },
  },
  calender: {
    borderRadius: "5px",
  },
  statusFilter: {
    position: "fixed",
    py: 1,
    px: 2
  },
  filterText: {
    fontSize: "12px",
    fontWeight: "500",
    mr: "2em"
  },
  label: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text
  },
  width: {
    // mr:{xs:0, md:"7px"}
  },
  widths: {
    // mr:{xs:0, md:2}
  },

  containerInput: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    justifyContent: "space-between",
    alignItems: { xs: "stretch", md: "flex-start" },
    width: "100%",
    gap: { xs: 2, md: 0 },

  },
  datePickerContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    minWidth: 0, // Prevents overflow issues
  },
  datePicker: {
    width: "100%",
  },
  datePickerField: {
    width: "100%",
  },
  fromTogrid: {
    display: { xs: "block", md: "flex" },
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
  },
  statusBtn:
  {
    border: "1px solid #28AA4A ",
    borderRadius: "10px",
    ml: 5,
    mx: { xs: "20px" },
    mt: { xs: "15px", sm: "5px" },
    width: "fit-content",
  },
  name: {
    color: color.text,
    fontSize: "14px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    fontWeight: "400",
    textTransform: "capitalize"

  },
  mail: {
    color: color.lightText,
    fontSize: "14px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    fontWeight: "400"
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    pl: 4
  },
  checkinBtn:
  {
    borderRadius: 50,
    // backgroundColor: "#28AA4A",
    color: "#fff",
    ml: "8px",
    textTransform: "none",
    fontSize: "12px",
  },
  checkoutBtn: {
    borderRadius: 50,
    // backgroundColor: "#DEDEDE", 
    color: color.card,
    ml: "8px",
    textTransform: "none",
    fontSize: "12px",
    boxShadow: "none"
  },
  exportBtn: {
    borderRadius: 50,
    // backgroundColor: "#DEDEDE", 
    color: color.secondary,
    border: "1px solid #00ABF4",
    ml: "8px",
    textTransform: "none",
    fontSize: "12px",
    boxShadow: "none",
    py: "4px",
    px: "8px",
    "& svg": {
      mr: 1
    }

  }


};
export default styles;